export enum PdgmAdmissionSourceEnum {
  Community = 1,
  Institutional = 2
}

export const PdgmAdmissionSourceOptions = [
{ id: 1, label: 'Community' },
{ id: 2, label: 'Institutional' }
];
